import React from "react";

const PrivacyPolicy = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto bg-white p-8 rounded-2xl shadow-xl">
                <h1 className="text-4xl font-bold text-center text-blue-800 mb-2">Privacy Policy</h1>
                <p className="text-sm text-center text-gray-500 mb-8">
                    Effective Date: <strong>[01-04-2024]</strong> | Last Updated: <strong>[01-04-2024]</strong>
                </p>

                <section className="space-y-6 text-gray-700 leading-relaxed">
                    <p>
                        <strong>Riyms Micro Foundation</strong> (&quot;Company&quot;, &quot;we&quot;, &quot;our&quot;, or &quot;us&quot;)
                        respects your privacy and is committed to protecting your personal information.
                        This Privacy Policy outlines how we collect, use, share, and protect your information
                        when you use our mobile application and microfinance services under Section 8 of the Companies Act, 2013.
                    </p>

                    <div>
                        <h2 className="text-2xl font-semibold text-blue-700 mb-2">1. Information We Collect</h2>
                        <ul className="list-disc list-inside space-y-1">
                            <li><strong>Personal Information:</strong> Full name, DOB, phone number, Aadhaar, PAN, address, etc.</li>
                            <li><strong>Financial Information:</strong> Bank details, income proof, credit history, UPI info.</li>
                            <li><strong>Device &amp; Usage:</strong> IMEI, IP, location, SMS logs (with consent), usage analytics.</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-blue-700 mb-2">2. How We Use Your Information</h2>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Verify your identity and assess loan eligibility</li>
                            <li>Process loan disbursements and manage repayments</li>
                            <li>Comply with KYC, AML, and legal obligations</li>
                            <li>Enhance service functionality and prevent fraud</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-blue-700 mb-2">3. Sharing of Information</h2>
                        <p>We do not sell or rent your personal data. However, we may share your data with:</p>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Credit bureaus, banks, and payment processors</li>
                            <li>Regulatory authorities like RBI and other government bodies</li>
                            <li>Third-party vendors under strict confidentiality contracts</li>
                        </ul>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-blue-700 mb-2">4. Data Security</h2>
                        <p>We implement industry-standard encryption, secure cloud infrastructure, and access controls.
                            While we strive for top-tier security, no digital platform is entirely immune. Please protect your credentials responsibly.</p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-blue-700 mb-2">5. Your Rights and Choices</h2>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Access and correct your personal data</li>
                            <li>Withdraw consent (may affect app functionality)</li>
                            <li>Request data deletion (subject to compliance requirements)</li>
                        </ul>
                        <p className="mt-1">Contact us at: <strong>{`pardeep1982yogita@gmail.com`}</strong></p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-blue-700 mb-2">6. Retention of Information</h2>
                        <p>We retain your data as long as required to fulfill financial services, comply with laws,
                            or resolve disputes — typically up to 7 years from the end of service.</p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-blue-700 mb-2">7. Children&apos;s Privacy</h2>
                        <p>Our services are not intended for individuals under 18 years old. We do not knowingly collect data from minors.</p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-blue-700 mb-2">8. Changes to This Policy</h2>
                        <p>We may update this Privacy Policy periodically. Material changes will be communicated via app notifications or email alerts.</p>
                    </div>

                    <div>
                        <h2 className="text-2xl font-semibold text-blue-700 mb-2">9. Contact Us</h2>
                        <p>
                            <strong>Riyms Micro Foundation</strong><br />
                            {`PLOT NO 146, WARD NO 1,SAFIDON, 126112, India, NA, SAFIDON, Jind-126112, Haryana,India`}<br />
                            Email: {`pardeep1982yogita@gmail.com`} <br />
                            Phone: 9255935551 <br />
                        </p>
                    </div>

                    <p className="text-sm text-gray-500 mt-6">
                        This policy complies with the Information Technology Act, 2000 and RBI&apos;s Fair Practices Code for Microfinance Institutions.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
